/* eslint-disable no-undefined */
/* eslint-disable react/no-did-update-set-state */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import GroupIcon from '@material-ui/icons/GroupWork';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { LIGHTBLUE, LIGHTGREY, DEEPORANGE } from '../../utils/color_utils';
import firebase from '../../store/firebase';
import Badge from '@material-ui/core/Badge';
import { SET_SEEN_GROUP_NOTIFICATIONS } from '../../store/actions/types';
import { fetchUserData } from '../../store/actions/userActions';
import GroupsListAll from './GroupsListAll';

const styles = theme => ({
  root: {
    flexGrow: 1,
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
  },
  groupslabel: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: LIGHTBLUE,
    textTransform: 'uppercase',
    fontWeight: 'bold',
    borderBottom: `1px solid ${LIGHTGREY}`,
    padding: theme.spacing(),
    fontSize: '0.8rem',
    lineHeight: 1.2,
  },
  groupText: {
    fontSize: '0.8rem',
    lineHeight: 2.2,
    display: 'inline-block',
  },
  badge: {
    backgroundColor: DEEPORANGE,
    padding: 0,
    borderRadius: 4,
    color: '#fff',
    marginLeft: '8px',
    fontSize: '0.5rem',
  },
  listItem: {
    padding: '4px 8px',
    backgroundColor: '#fff',
    fontSize: '0.585rem',
    '&:hover': {
      backgroundColor: '#eee',
    },
  },
  list: {
    maxHeight: '200px',
    minHeight: '100px',
    overflowY: 'auto !important',
    backgroundColor: '#fff',
    border: '1px solid #ccc', // Remove after verifying scrolling
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#f1f1f1',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#888',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#555',
    },
  },
  groupsListAll: {
    marginTop: theme.spacing(2),
    flex: 1,
  },
});

class GroupsList extends Component {
  state = {
    groups: [],
    initPosts: false,
  };

  async componentDidMount() {
    let database = firebase.database;
    let ref = 'company_groups/' + this.props.userdata.companyID;

    try {
      
      
      const snapshot = await database.ref(ref).once('value');
      
      const groupsArr = [];
      const promises = [];

      snapshot.forEach(childSnapshot => {
        
        if (childSnapshot.val().active === true || childSnapshot.val().active === undefined) {
          
          promises.push(
            (async () => {
              const inGroup = await this.userInGroup(
                this.props.userdata.userID,
                childSnapshot.val().group_id,
                this.props.userdata.companyID
              );
              
              if (inGroup === 2) {
                
                groupsArr.push({
                  id: childSnapshot.key,
                  group_id: childSnapshot.val().group_id,
                  group_name: childSnapshot.val().group_name,
                  group_details: childSnapshot.val(),
                });
              }
            })()
          );
        }
      });

      await Promise.all(promises);
      
      this.setState({ groups: groupsArr });
    } catch (error) {
      
    }
  }

  componentDidUpdate() {
    if (this.state.initPosts === false) {
      if (this.state.groups.length > 0) {
        
        this.props.selectedGroup(this.state.groups[0]);
        this.props.fetchUserData({
          type: SET_SEEN_GROUP_NOTIFICATIONS,
          userID: this.props.userdata.userID,
          groupid: this.state.groups[0].group_id,
          unseengroupnotifications: this.props.unseengroupnotifications.unseengroupnotifications,
        });
      }
      this.setState({ initPosts: true });
    }
  }

  selectedList = (id, item) => {
    
    this.props.selectedGroup(item);
    this.props.fetchUserData({
      type: SET_SEEN_GROUP_NOTIFICATIONS,
      userID: this.props.userdata.userID,
      groupid: item.group_id,
      unseengroupnotifications: this.props.unseengroupnotifications.unseengroupnotifications,
    });
  };

  async userInGroup(userID, groupID, companyID) {
    
    try {
      const database = firebase.database;
      const snapshot = await database
        .ref(`company_groups_users/${companyID}/${groupID}/${userID}`)
        .once('value');

      
      if (snapshot.exists()) {
        const userData = snapshot.val();
        return userData.active ? 2 : 1;
      } else {
        return 3;
      }
    } catch (error) {
      
      return 3;
    }
  }

  render() {
    const { classes, unseengroupnotifications } = this.props;
    

    return (
      <div style={{ height: '100vh', overflow: 'hidden' }}>
        <div className={classes.root}>
          <Typography
            className={classes.groupslabel}
            variant="subtitle2"
            gutterBottom
          >
            <GroupIcon /> My Groups
          </Typography>
          <List
            component="nav"
            aria-label="Secondary mailbox folders"
            className={classes.list}
          >
            {this.state.groups
              ? this.state.groups.map(item => {
                  return (
                    <ListItem
                      button
                      divider={true}
                      key={item.id}
                      onClick={this.selectedList.bind(this, item.id, item.group_details)}
                      className={classes.listItem}
                    >
                      <ListItemText
                        primary={
                          <Typography className={classes.groupText} component="strong">
                            {item.group_name}
                            <Badge
                              invisible={
                                unseengroupnotifications[item.group_id] ? false : true
                              }
                              badgeContent={
                                <span className={classes.badge}>
                                  {unseengroupnotifications[item.group_id]}
                                </span>
                              }
                            />
                          </Typography>
                        }
                      />
                    </ListItem>
                  );
                })
              : <div style={{ textAlign: 'center', padding: '50px 20px 20px' }}>
                  No groups available
                </div>}
          </List>
          <GroupsListAll
            className={classes.groupsListAll}
            companyID={this.props.userdata.companyID}
            userID={this.props.userdata.userID}
            userEmail={this.props.userdata.email}
            firstName={this.props.userdata.firstName}
            lastName={this.props.userdata.lastName}
          />
        </div>
      </div>
    );
  }
}

GroupsList.propTypes = {
  classes: PropTypes.object.isRequired,
  selectedGroup: PropTypes.func.isRequired,
};

const GroupsListStyled = withStyles(styles)(GroupsList);

const mapStateToProps = state => {
  return {
    userdata: state.userDialog.userDetails[0],
    unseengroupnotifications: state.userdata.unseengroupnotifications,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchUserData: params => dispatch(fetchUserData(params)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GroupsListStyled);
///////////////////////////////////////////////////////////////////////////////////
// /* eslint-disable no-undefined */
// /* eslint-disable react/no-did-update-set-state */
// import React, { Component } from 'react';
// import PropTypes from 'prop-types';
// import { connect } from 'react-redux';
// import { withStyles } from '@material-ui/core/styles';
// import Typography from '@material-ui/core/Typography';
// import GroupIcon from '@material-ui/icons/GroupWork';
// import List from '@material-ui/core/List';
// import ListItem from '@material-ui/core/ListItem';
// import ListItemText from '@material-ui/core/ListItemText';
// import { LIGHTBLUE, LIGHTGREY, DEEPORANGE } from '../../utils/color_utils';
// import firebase from '../../store/firebase';
// import Badge from '@material-ui/core/Badge';
// import { SET_SEEN_GROUP_NOTIFICATIONS } from '../../store/actions/types';
// import { fetchUserData } from '../../store/actions/userActions';
// import GroupsListAll from './GroupsListAll';

// const styles = theme => ({
//   root: {
//     flexGrow: 1,
//     marginLeft: theme.spacing(),
//     marginRight: theme.spacing(),
//     display: 'flex',
//     flexDirection: 'column',
//     height: '100%',
//     overflow: 'hidden',
//   },
//   groupslabel: {
//     display: 'flex',
//     flexDirection: 'row',
//     alignItems: 'center',
//     color: LIGHTBLUE,
//     textTransform: 'uppercase',
//     fontWeight: 'bold',
//     borderBottom: `1px solid ${LIGHTGREY}`,
//     padding: theme.spacing(),
//     fontSize: '0.8rem',
//     lineHeight: 1.2,
//   },
//   groupText: {
//     fontSize: '0.8rem',
//     lineHeight: 2.2,
//     display: 'inline-block',
//   },
//   badge: {
//     backgroundColor: DEEPORANGE,
//     padding: 0,
//     borderRadius: 4,
//     color: '#fff',
//     marginLeft: '8px',
//     fontSize: '0.5rem',
//   },
//   listItem: {
//     padding: '4px 8px',
//     backgroundColor: '#fff',
//     fontSize: '0.585rem',
//     '&:hover': {
//       backgroundColor: '#eee',
//     },
//   },
//   list: {
//     maxHeight: '200px',
//     minHeight: '100px',
//     overflowY: 'auto !important',
//     backgroundColor: '#fff',
//     border: '1px solid #ccc',
//     '&::-webkit-scrollbar': {
//       width: '8px',
//     },
//     '&::-webkit-scrollbar-track': {
//       background: '#f1f1f1',
//     },
//     '&::-webkit-scrollbar-thumb': {
//       background: '#888',
//       borderRadius: '4px',
//     },
//     '&::-webkit-scrollbar-thumb:hover': {
//       background: '#555',
//     },
//   },
//   groupsListAll: {
//     marginTop: theme.spacing(2),
//     flex: 1,
//   },
// });

// class GroupsList extends Component {
//   state = {
//     groups: [],
//     initPosts: false,
//   };

//   async componentDidMount() {
//     // Mock data for testing
//     const mockGroups = Array.from({ length: 20 }, (_, i) => ({
//       id: `test-${i}`,
//       group_id: `group-${i}`,
//       group_name: `Group ${i + 1}`,
//       group_details: {},
//     }));
//     this.setState({ groups: mockGroups });

//     // Original Firebase logic (commented for testing)
//     /*
//     let database = firebase.database;
//     let ref = 'company_groups/' + this.props.userdata.companyID;
//     try {
//       const snapshot = await database.ref(ref).once('value');
//       const groupsArr = [];
//       const promises = [];
//       snapshot.forEach(childSnapshot => {
//         if (childSnapshot.val().active === true || childSnapshot.val().active === undefined) {
//           promises.push(
//             (async () => {
//               const inGroup = await this.userInGroup(
//                 this.props.userdata.userID,
//                 childSnapshot.val().group_id,
//                 this.props.userdata.companyID
//               );
//               if (inGroup === 2) {
//                 groupsArr.push({
//                   id: childSnapshot.key,
//                   group_id: childSnapshot.val().group_id,
//                   group_name: childSnapshot.val().group_name,
//                   group_details: childSnapshot.val(),
//                 });
//               }
//             })()
//           );
//         }
//       });
//       await Promise.all(promises);
//       this.setState({ groups: groupsArr });
//     } catch (error) {
//     }
//     */
//   }

//   componentDidUpdate() {
//     if (this.state.initPosts === false) {
//       if (this.state.groups.length > 0) {
//         this.props.selectedGroup(this.state.groups[0]);
//         this.props.fetchUserData({
//           type: SET_SEEN_GROUP_NOTIFICATIONS,
//           userID: this.props.userdata.userID,
//           groupid: this.state.groups[0].group_id,
//           unseengroupnotifications: this.props.unseengroupnotifications.unseengroupnotifications,
//         });
//       }
//       this.setState({ initPosts: true });
//     }
//   }

//   selectedList = (id, item) => {
//     this.props.selectedGroup(item);
//     this.props.fetchUserData({
//       type: SET_SEEN_GROUP_NOTIFICATIONS,
//       userID: this.props.userdata.userID,
//       groupid: item.group_id,
//       unseengroupnotifications: this.props.unseengroupnotifications.unseengroupnotifications,
//     });
//   };

//   async userInGroup(userID, groupID, companyID) {
//     try {
//       const database = firebase.database;
//       const snapshot = await database
//         .ref(`company_groups_users/${companyID}/${groupID}/${userID}`)
//         .once('value');


//       if (snapshot.exists()) {
//         const userData = snapshot.val();
//         return userData.active ? 2 : 1;
//       } else {
//         return 3;
//       }
//     } catch (error) {
//       return 3;
//     }
//   }

//   render() {
//     const { classes, unseengroupnotifications } = this.props;

//     return (
//       <div style={{ height: '100vh', overflow: 'hidden' }}>
//         <div className={classes.root}>
//           <Typography
//             className={classes.groupslabel}
//             variant="subtitle2"
//             gutterBottom
//           >
//             <GroupIcon /> My Groups
//           </Typography>
//           <List
//             component="nav"
//             aria-label="Secondary mailbox folders"
//             className={classes.list}
//           >
//             {this.state.groups
//               ? this.state.groups.map(item => {
//                   return (
//                     <ListItem
//                       button
//                       divider={true}
//                       key={item.id}
//                       onClick={this.selectedList.bind(this, item.id, item.group_details)}
//                       className={classes.listItem}
//                     >
//                       <ListItemText
//                         primary={
//                           <Typography className={classes.groupText} component="strong">
//                             {item.group_name}
//                             <Badge
//                               invisible={
//                                 unseengroupnotifications[item.group_id] ? false : true
//                               }
//                               badgeContent={
//                                 <span className={classes.badge}>
//                                   {unseengroupnotifications[item.group_id]}
//                                 </span>
//                               }
//                             />
//                           </Typography>
//                         }
//                       />
//                     </ListItem>
//                   );
//                 })
//               : <div style={{ textAlign: 'center', padding: '50px 20px 20px' }}>
//                   No groups available
//                 </div>}
//           </List>
//           <GroupsListAll
//             className={classes.groupsListAll}
//             companyID={this.props.userdata.companyID}
//             userID={this.props.userdata.userID}
//             userEmail={this.props.userdata.email}
//             firstName={this.props.userdata.firstName}
//             lastName={this.props.userdata.lastName}
//           />
//         </div>
//       </div>
//     );
//   }
// }

// GroupsList.propTypes = {
//   classes: PropTypes.object.isRequired,
//   selectedGroup: PropTypes.func.isRequired,
// };

// const GroupsListStyled = withStyles(styles)(GroupsList);

// const mapStateToProps = state => {
//   return {
//     userdata: state.userDialog.userDetails[0],
//     unseengroupnotifications: state.userdata.unseengroupnotifications,
//   };
// };

// const mapDispatchToProps = dispatch => {
//   return {
//     fetchUserData: params => dispatch(fetchUserData(params)),
//   };
// };

// export default connect(mapStateToProps, mapDispatchToProps)(GroupsListStyled);